import { createStore } from 'vuex';
import axios from 'axios';
import mainService from '@/services/mainService';
import authService from '@/services/mainService';
 
const store = createStore({
  state: {
    user: null, // Kullanıcı verisi
    sellerList: [],
    userList: [],
    brandList: [],
    customerList: [],
    categoryList: [],
   },
  mutations: {

    
    setUser(state, user) {
      state.user = user;
    },
    setUsers(state, users) {
      state.userList = users;
    },
    setSellers(state, sellers) {
      state.sellerList = sellers;
    },
    setBrands(state, brands) {
      state.brandList = brands;
    },
    setCustomers(state, customers) {
      state.customerList = customers;
    },
    setCategories(state, categories) {
      state.categoryList = categories;
    },
 
  },
  actions: {
    loadUser({ commit }) {
      const user = localStorage.getItem('user');
      if (user) {
        commit('setUser', JSON.parse(user)); // Kullanıcı verisini state'e kaydet
      }
    },
    async fetchSellerList({ commit }) {
      try {
        const token = localStorage.getItem("user");
        if (token) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${
            JSON.parse(token).access_token
          }`;
        }
        const response = await axios.get('https://phone360.net/api/sellers');
        const fetchedSellers = response.data; // Yanıtın data kısmını kullanın
        commit('setSellers', fetchedSellers.map((seller) => ({
          title: seller.name, // Görüntülenecek marka adı
          id: seller.id, // Seçildiğinde kaydedilecek marka ID'si
          status: seller.status, // Seçildiğinde kaydedilecek marka ID'si
        })));
      } catch (error) {
        console.error("Error fetching sellers:", error);
      }
    },
    async fetchCatgeoryList({ commit }) {
      try {
        const token = localStorage.getItem("user");
        if (token) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${
            JSON.parse(token).access_token
          }`;
        }
        const response = await axios.get('https://phone360.net/api/categories');
        const fetchedCategories= response.data; // Yanıtın data kısmını kullanın
        commit('setCategories', fetchedCategories.map((categories) => ({
          title: categories.title, // Görüntülenecek marka adı
          id: categories.id, // Seçildiğinde kaydedilecek marka ID'si
          parent: categories.parent, // Seçildiğinde kaydedilecek marka ID'si
        })));
      } catch (error) {
        console.error("Error fetching sellers:", error);
      }
    },
    async fetchUserList({ commit },query) {
      if (query.length < 2) {
        this.userList = []; // Arama metni 2 karakterden azsa temizle
        return;
      }
      try {
        const response = await authService.search(query, "users"); // Müşteri arama servisi
        const mappedCUsers = response.map((user) => ({
          title: user.title, // Görüntülenecek müşteri adı
          id: user.id // Seçildiğinde kaydedilecek müşteri ID'si
        }));
        
        commit('setUsers', mappedCUsers);
      } catch (error) {
        console.error("Müşteri arama hatası:", error);
       } finally {
        this.loading = false; // Yükleniyor durumunu bitir
      }
    },
    async fetchBrandList({ commit }) {
      try {
        const token = localStorage.getItem("user");
        if (token) {
          axios.defaults.headers.common["Authorization"] = `Bearer ${
            JSON.parse(token).access_token
          }`;
        }
        const response = await axios.get('https://phone360.net/api/brands');
        const fetchedBrands = response.data; // Yanıtın data kısmını kullanın
        commit('setBrands', fetchedBrands);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    },
    async fetchCustomers({ commit }, searchTerm) {
      if (searchTerm.length < 2) {
        commit('setCustomers', []);
        return;
      }
    
      commit('setLoading', true);
    
      try {
        const response = await mainService.search(searchTerm, "customers");
        
        if (response && Array.isArray(response)) {
          const mappedCustomers = response.map((customer) => ({
            title: customer.title, // Görüntülenecek müşteri adı
            id: customer.id // Seçildiğinde kaydedilecek müşteri ID'si
          }));
          
          commit('setCustomers', mappedCustomers);
        } else {
          console.error("Beklenmeyen yanıt:", response);
          commit('setCustomers', []);
        }
      } catch (error) {
        console.error("Müşteri arama hatası:", error);
        commit('setCustomers', []);
      } finally {
        commit('setLoading', false);
      }
    }
    

  },
});

export default store;

